// components/FAQ.js
import React from 'react';
import './FAQ.css';

const FAQ = () => {
  const faqItems = [
    {
      question: "Can I change plans anytime?",
      answer: "Yes, you can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle."
    },
    {
      question: "Is there a setup fee?",
      answer: "No, there are no setup fees for any of our plans. You only pay the yearly subscription cost."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards and bank transfers for annual plans."
    },
    {
      question: "Do you offer hardware?",
      answer: "Yes, we offer compatible hardware packages including tablets, card readers, and receipt printers at competitive prices."
    },
    {
      question: "Is my data secure?",
      answer: "Absolutely. We use bank-level encryption and comply with all PCI DSS security standards to keep your data safe."
    },
    {
      question: "How long does setup take?",
      answer: "Most businesses can get up and running in less than 24 hours. Our onboarding team provides assistance to ensure a smooth transition."
    }
  ];

  return (
    <section id="faq" className="section faq-section">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        
        <div className="faq-grid">
          {faqItems.map((item, index) => (
            <div key={index} className="faq-item">
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;